<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <div class="page__title">
      Авторизация
    </div>
    <div class="page__subtitle">
      Введите свои учетные данные или зарегистрируйтесь
    </div>
    <div class="text_field__container">
      <v-form
          v-model="valid"
          class="text_field__container"
      >
        <v-text-field
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            name="login"
            :rules="[rules.email]"
            v-model="email"
            :loading="loading"
        >
          <template v-slot:label>
            <div class="label__text">
              Электронная почта
            </div>
          </template>
        </v-text-field>
        <v-text-field
            id="password"
            v-model="password"
            :append-inner-icon="show ? 'visibility_off' : 'visibility'"
            :type="show ? 'text' : 'password'"
            :rules="[rules.required, rules.symbControl]"
            :loading="loading"
            @click:appendInner="show = !show"
            @keyup.enter="login"
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
        >
          <template v-slot:label>
            <div class="label__text">
              Пароль
            </div>
          </template>
        </v-text-field>
      </v-form>
      <div class="text__field">
        <v-alert
            class="error_alert"
            v-if="error"
            :value="true"
            outline
            :icon="false"
            color="#8f0808"
            variant="outlined"
        >
          {{error.error}}
        </v-alert>
      </div>
      <v-btn
          class="btn__next"
          elevation="0"
          :disabled="!valid"
          :loading="loading"
          @click="login"
      >
        <span class="btn__next_text">
          Войти
        </span>
      </v-btn>
      <v-row no-gutters justify="space-between" class="btn_regfog__container">
        <v-col cols="12" lg="6" class="btn_regfog__text" @click="$router.push({name: names.CREATE_USER.PAGE})">Зарегистрироваться</v-col>
        <v-col cols="12" lg="6" class="btn_regfog__text" @click="$router.push({name: names.RECOVERY.PAGE})">Забыли пароль?</v-col>
      </v-row>
      <v-row no-gutters justify="center" class="other_auth__container">
        <p class="other_auth__text">Или войти через</p>
      </v-row>
      <v-row no-gutters justify="center" class="other_auth__container">
        <span class="other_auth__btn btn_science_id" @click="authScienceId">
          <span class=ml-1>science-id</span>
        </span>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"

export default defineComponent({
  name: "Authorization",
  data () {
    return {
      loading: false,
      valid: false,
      email: null,
      password: null,
      show: false,
      error: null,
      rules: {
        required: value => !!value || 'Введите пароль',
        symbControl: value => this.symbControl(value) || 'Некорректный ввод',
        email: value => {
          if (value !== null && value !== '') {
            const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Введите адрес Вашей электронной почты'
          }
        },
      }
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    from () {
      // eslint-disable-next-line
      if (this.$route.query.hasOwnProperty('from')) {
        return this.$route.query.from
      } else {
        return null
      }
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      hasCookie: 'auth/hasCookie'
    })
  },
  methods: {
    ...mapActions({
      authLogin: 'auth/LOGIN_AS_USER',
      oauthScienceId: 'auth/SCIENCE_ID_OAUTH_REDIRECT',
    }),
    endRedirect () {
      if (this.from !== null) {
        document.location.href = this.from
      } else if (this.$route.query.redirect !== undefined) {
        this.$router.push({ path: this.$route.query.redirect })
      } else {
        this.$router.push({ name: pa_names.MAIN })
      }
    },
    login: function () {
      this.loading = true
      const user = {
        email: String(this.email).trim(),
        password: String(this.password).trim()
      }
      this.error = null
      this.authLogin(
        {
          user,
          finalizer: () => {
            this.loading = false
            this.error = null
            this.endRedirect()
          },
          catcher: (error) => {
            this.loading = false
            this.error = error
          }
        }
      )
    },
    authScienceId () {
      this.loading = true
      this.error = null
      this.oauthScienceId(
        {
          finalizer: (data) => {
            this.loading = false
            this.error = null
            document.location.href = data.redirect
          },
          catcher: (error) => {
            this.loading = false
            this.error = error
          }
        }
      )
    },
    symbControl: function (value) {
      if (value === null) {
        return true
      }
      return !(value.includes(' ') || value.includes('\n'))
    }
  },
  created () {
    if (this.isAuthenticated) { this.endRedirect() }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 500px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.btn_regfog__container {
  width: 100%;
  margin-bottom: 50px;
}

.btn_regfog__text {
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration-line: underline;
  color: #3254B9;

  &:last-child {
    justify-content: end;
  }
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
  margin-bottom: 20px;
}

.other_auth__container {
  width: 100%;
}

.other_auth__text {
  margin-bottom: 25px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #959595;
}

.other_auth__btn {
  margin-bottom: 50px;
}

.btn_science_id {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  padding: 0 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #3254B9;
  border: 1px solid #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: #3254B9;
    color: #FFFFFF;
  }

  &.click {
    background-color: #3254B9;
    color: #FFFFFF;
  }
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .btn_regfog__text {
    font-size: 22px;
    line-height: 27px;
  }

  .btn_regfog__text {
    justify-content: center;

    &:last-child {
      margin-top: 15px;
      justify-content: center;
    }
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn_regfog__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn_regfog__text {
    justify-content: center;

    &:last-child {
      margin-top: 15px;
      justify-content: center;
    }
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
